function loadProducts(callback) {
    $('.sidebar__reset').addClass('d-none');
    $('#loader').removeClass('d-none');
    $('.load-more').addClass('d-none');
    $.post(article_get_url+'?v='+uniqid(), {
        page: page,
        catalogCode: catalogCode,
        urlChain: urlChain,
        filters: filters,
        // numFilters: numFilters,
        sort: sort,
        tgmList: (typeof tgmList != 'undefined' ? tgmList : '')
    }, function (data) {

        var impressions = [];
        for(var i = 0; i < data.articles.length; i++) {
            impressions.push({
                'name': data.articles[i].name,
                'id': (data.articles[i].associationField ? data.articles[i].associationField : data.articles[i].code),
                'price': parseFloat(data.articles[i].price).toFixed(2),
                'brand': data.articles[i].brand_name,
                'category': null,
                'list': data.tgmList,
                'position': parseInt(i) + 1 + (parseInt(data.page) - 1) * pagination
            });
        }
        if (env == 'dev') {
            console.log('impressions', impressions);
        }
        tagManager_impression(impressions, data.tgmList);

        $('#article-total-text').text((data.totalArticles > 1 || data.totalArticles == 0) ? string_products : string_product);
        $('#article-total').text(data.totalArticles);
        $('#loader').addClass('d-none');
        if (data.showLoadMore) {
            $('.load-more').removeClass('d-none');
        }
//                history.pushState(null, null, current_url + '?page='+page+(filters.length > 0 ? '&filters='+JSON.stringify(filters) : '')+(numFilters.length > 0 ? '&numFilters='+JSON.stringify(numFilters) : '')+'&sort='+sort);
        history.pushState(null, null, current_url + '?page='+page+'&sort='+sort+'&filters='+JSON.stringify(filters));
        callback(data);
    });
}

$('.load-more').click(function () {
    page = page + 1;
    loadProducts(function (data) {
        $('#article-wrapper').append(data.html);
    });
});

// SORT

$('#sort-catalog').change(function () {
  $('#loader').removeClass('d-none');
  $('#article-wrapper').html('');
  sort = $('#sort-catalog').val();
  page = 1;
  loadProducts(function (data) {
    $('#article-wrapper').html(data.html);
    scrollToStart('article-wrapper');
  });
});

function resetFilters() {
  filters = [];
  numFilters = [];
  $('.filter:checked').prop('checked', false);
  $('.num-filters').val(null);
  setTimeout(function () {
    loadProducts(function (data) {
      $('#article-wrapper').html(data.html);
      scrollToStart('article-wrapper');
    });
  }, 500);
}

// filter

function checkFilters()
{
    var count = $('.js-filter').length;
    // console.log(count);
    filters = [];
    sort = $('#sort-catalog').val();
    page = 1;
    if (count) {
        $('.js-filter').each(function (k, v) {
            // console.log($(v).attr('id'));
            // console.log($(v).attr('type'), $(v).is(':checked'));
            // console.log($(v).val());
            if ($(v).attr('type') == 'checkbox') {
                if ($(v).is(':checked')) {
                    filters.push({
                        'k': $(v).attr('data-key'),
                        'v': 1
                    });
                }
            } else {
                if ($(v).val()) {
                    filters.push({
                        'k': $(v).attr('data-key'),
                        'v': $(v).val()
                    });
                }
            }
            if (!--count) {
                setTimeout(function () {

                    if (filters.length) {
                        $('.js-filter-reset').each(function (k, v) {
                            console.log($(v).attr('data-show-classes'));
                            $(v).attr('class', $(v).attr('data-show-classes'));
                        });
                    } else {
                        $('.js-filter-reset').each(function (k, v) {
                            console.log($(v).attr('data-hide-classes'));
                            $(v).attr('class', $(v).attr('data-hide-classes'));
                        });
                    }

                    loadProducts(function (data) {
                        $('#article-wrapper').html(data.html);
                        // scrollToStart('article-wrapper');
                    });
                }, 250);
            }
        });
    } else {
        setTimeout(function () {
            loadProducts(function (data) {
                $('#article-wrapper').html(data.html);
                // scrollToStart('article-wrapper');
            });
        }, 250);
    }
}

$('.js-filter').change(function () {
    checkFilters();
});


$('.js-filter-reset').click(function () {
    $('select.js-filter').val(null);
    $('input.js-filter').prop('checked', false);
    setTimeout(function () {
        checkFilters();
    }, 250);
});
